import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppId, AppThunkAPIType } from "../../../app/appTypes";
import { DocumentHeader } from "../documentsApi";
import { DocumentCreationModes, DocumentLanguages, DocumentTypes, UrsNumberingMode } from "../documentTypes";
import { getWithAuth, postWithAuth } from "../../../http";

export interface CreateDocumentTemplatePayload {
    documentType: DocumentTypes;
    structureId: string;
    documentNumber: string;
    title: string;
    docDesignation: string;
    templateId: string;
    copyDocumentId: number;
    language: DocumentLanguages;
    creationMode: DocumentCreationModes;
    numberingMode: UrsNumberingMode | undefined;
}

export const loadClientDocumentTemplates =
    createAsyncThunk<DocumentHeader[], void, AppThunkAPIType>("client/load-templates", async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: "api/document-templates"
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as DocumentHeader[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })


export type LoadTemplatesForStructureParams = {
    structureId: number;
    documentType: string;
};

export const loadClientDocumentTemplatesForStructure =
    createAsyncThunk<DocumentHeader[], LoadTemplatesForStructureParams, AppThunkAPIType>(
        "client/load-templates-for-structure",
        async (args, { dispatch, rejectWithValue }) => {
            const { structureId, documentType } = args;

            const qs = new URLSearchParams();
            qs.set("structureId", String(structureId));
            if (documentType && documentType.trim()) qs.set("documentType", documentType.trim());

            const result = await dispatch(
                getWithAuth({
                    url: `api/document-templates/for-structure?${qs.toString()}`,
                })
            );

            const { payload } = result;

            if (getWithAuth.fulfilled.match(result)) {
                return payload as DocumentHeader[];
            } else {
                return rejectWithValue(payload ?? { kind: "unknown" });
            }
        }
    );

export const createClientDocumentTemplate = createAsyncThunk<DocumentHeader, CreateDocumentTemplatePayload, AppThunkAPIType>(
    "clientdocumenttemplate/create",
    async (data: CreateDocumentTemplatePayload, { rejectWithValue, dispatch }) => {
        const result = await dispatch(postWithAuth({
            url: "api/document-templates",
            payload: data,
        }))
        const { payload } = result

        if (postWithAuth.fulfilled.match(result)) {
            return payload as DocumentHeader
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)
